<template>
  <button
    id="goToBottom"
    @click="goBottom()"
  >
    <i class="fas fa-arrow-down" />
  </button>
</template>

<script>
import $ from 'jquery'
export default {
  data () {
    return {
    }
  },
  created () {
    $(window).scroll(function () {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
        $('#goToBottom').stop(true, true).fadeOut('slow')
      } else {
        $('#goToBottom').stop(true, true).fadeIn('slow')
      }
    })
  },

  methods: {
    goBottom () {
      window.scrollTo(0, document.body.scrollHeight)
    }
  }
}
</script>

<style scoped lang="scss">
#goToBottom {
    max-width: 2em;
    max-height: 2em;
    display: none;
    position: fixed;
    opacity: 0.6;
    bottom: 60px;
    right: 30px;
    z-index: 999999;
    font-size: 18px;
    border: none;
    outline: none;
    background-color: #f79000;
    color: white;
    cursor: pointer;
    padding: 2px 13px 6px 10px;
    border-radius: 50%;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    transition: all 0.3s cubic-bezier(.25,.8,.25,1);
}

#goToBottom:hover {
    opacity: 1;
    background-color: #f7a733;
}

</style>
